import React from 'react'

export const NoAccess = () => {
  return (
    <h1>

    </h1>
  )
}
